import http from './http'
import { setCookie, removeCookie } from './cookie'

export const PENDING_TENANTS_KEY = 'pendingTenants'

export function normalizeLoginResponse (data) {
  return Array.isArray(data) ? data : [data]
}

export function savePendingTenants (tenants) {
  sessionStorage.setItem(PENDING_TENANTS_KEY, JSON.stringify(tenants))
}

export function getPendingTenants () {
  const raw = sessionStorage.getItem(PENDING_TENANTS_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function clearPendingTenants () {
  sessionStorage.removeItem(PENDING_TENANTS_KEY)
}

export function hasPendingTenants () {
  return getPendingTenants() != null
}

export function beginAccountSwitch () {
  localStorage.removeItem('user')
  removeCookie('token')
  removeCookie('tenantId')
  removeCookie('userId')
}

export function finalizeLogin (tenant, router) {
  setCookie('token', tenant.token, 23)
  setCookie('userId', tenant.userId, 23)
  setCookie('tenantId', tenant.tenantId, 23)

  return http.get(`/User/${tenant.userId}`)
    .then(resp => {
      if (resp.data.id) {
        localStorage.setItem('user', JSON.stringify(resp.data))
        if (resp.data.tenantId) {
          setCookie('tenantId', resp.data.tenantId, 23)
        }
        if (router) {
          return router.replace({ name: 'home' })
        }
      }
    })
    .catch(erro => {
      console.log(erro)
      throw erro
    })
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js